//import Polyfills from './polyfills'

import DomFactory from "./helpers/domFactory"

// import './scss/cph-web.scss'

export default class App {
  constructor() {
    this.domFactory = new DomFactory()
    return this
  }
}

window.app = new App()
